import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ModalComp } from "../../components";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllCourtsList } from "../../redux/Slice/Courts/CourtsListSlice";
import { DeleteCourt } from "../../utilities/api/courts";

const ArchiveCourt = ({ archive, setArchive, id }: any) => {
  const navigate = useNavigate();
  const { SelectedFacility } = useAppSelector(state => state.facilityList);
  const dispatch = useAppDispatch();
  const [message, setMessage] = useState("");

  const handleDelete = async () => {
    const result = await DeleteCourt(id);
    if (result?.status === 200) {
      setArchive(false);
      navigate("/courts");
      dispatch(AllCourtsList({ facilityId: SelectedFacility }));
    }
    if (result?.response?.status) {
      setMessage(result.response.data.message);
    }
  };
  return (
    <ModalComp
      archive={archive}
      setArchive={setArchive}
      handleDelete={handleDelete}
      message={message}
    />
  );
};

export { ArchiveCourt };
